import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import "./AppointmentCalendar.css";

import {
  loadAvailableDates,
  resetAvailableDates,
} from "../../../_redux/actions/appointmentActions";
import { RingLoader } from "@/_components";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS, enAU, es } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { brandColors } from "../../../_components/brandedComponent/BrandedColors";
import { LifeSafer } from "../../../_helpers/BrandConstants";
import { Australia } from "../../../_helpers/CountryConstants";

function AppointmentCalendar({
  appointmentLocation,
  availableDates,
  loadAvailableDates,
  resetAvailableDates,
  selectedDate,
  setSelectedDate,
  previousStep,
  enrolleeUserData,
  prefillDeviceType,
}) {
  const cookies = new Cookies();
  const siteCountry = cookies.get("siteCountry");
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const { t, i18n } = useTranslation();
  const [locale, setLocale] = useState();
  const today = new Date();
  const maxDate = new Date(moment(today).add(1, "M"));
  const initialValue = new Date(moment(today));

  const CustomTypo = styled(Typography)(() => ({
    zIndex: 10,
    fontWeight: 600,
    fontSize: 18,
  }));

  const BackButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== "brand",
  })(({ brand }) => ({
    backgroundColor: brandColors[brand]?.secondary,
    color: "white",
    "&:hover": {
      backgroundColor: brandColors[brand]?.secondary,
    },
    margin: 5,
  }));

  const CustomIcon = styled(InsertInvitationIcon, {
    shouldForwardProp: (prop) => prop !== "brand",
  })(({ brand }) => ({
    color: brandColors[brand]?.primary,
    height: 200,
    width: 200,
    opacity: 0.1,
  }));

  const CustomCardTypo = styled(Typography)(() => ({
    textAlign: "center",
    zIndex: 10,
    fontSize: 20,
    marginTop: -140,
  }));

  useEffect(() => {
    let startDate = today;

    // If ISA, pushing 7 days ahead
    if (prefillDeviceType === "ISA") {
      startDate = moment(today).add(7, "days").toDate();
    }
    let formattedAptDate =
      startDate.getFullYear() +
      "-" +
      (startDate.getMonth() > 8
        ? startDate.getMonth() + 1
        : "0" + (startDate.getMonth() + 1)) +
      "-" +
      (startDate.getDate() > 9
        ? startDate.getDate()
        : "0" + startDate.getDate());
    const vehicleId =
      enrolleeUserData.vehicleId === 0 ||
      enrolleeUserData.vehicleId === null ||
      enrolleeUserData.vehicleId === undefined
        ? ""
        : enrolleeUserData.vehicleId;
    loadAvailableDates(
      enrolleeUserData.clientId,
      vehicleId,
      appointmentLocation.locationID,
      prefillDeviceType,
      "Installation",
      formattedAptDate,
      appointmentLocation.sameDay,
    ).catch((error) => {
      console.error("Loading dates failed! " + error);
    });

    if (i18n.language.startsWith("en")) {
      if (siteCountry === Australia) {
        setLocale(enAU);
      } else {
        setLocale(enUS);
      }
    } else {
      setLocale(es);
    }
  }, []);

  useEffect(() => {
    if (i18n.language.startsWith("en")) {
      if (siteCountry === Australia) {
        setLocale(enAU);
      } else {
        setLocale(enUS);
      }
    } else {
      setLocale(es);
    }
  }, [i18n.language]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleGoBack = () => {
    resetAvailableDates();
    previousStep("Location");
  };

  function IsDayNotAvailable(day) {
    var date = new Date(day);
    const formattedDate =
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear();

    if (availableDates[0].CurrentState === "Undefined") {
      return false;
    } else {
      var found = { val: false };
      for (var i = 0; i < availableDates.length; i++) {
        if (
          availableDates[i].date &&
          availableDates[i].date != undefined &&
          availableDates[i].date.substr(0, 10) == formattedDate
        ) {
          found.val = true;
          break;
        }
      }
      return !found.val;
    }
  }

  // function DiscountedDays(props) {
  //   const { day, ...other } = props;

  //   // Does this day get the "Discount" icon
  //   let applyDiscount = highlightedDays.find(
  //     (x) => moment(x).format("YYYY-MM-DD") === moment(day).format("YYYY-MM-DD")
  //   );
  //   let isSelected = false;
  //   if (applyDiscount !== undefined && IsDayNotAvailable(day) === false)
  //     isSelected = true;

  //   return (
  //     <Badge
  //       key={props.day.toString()}
  //       overlap="circular"
  //       badgeContent={isSelected ? <PaidIcon /> : undefined}
  //     >
  //       <PickersDay {...other} day={day} />
  //     </Badge>
  //   );
  // }

  // DiscountedDays.propTypes = {
  //   day: PropTypes.any,
  // };

  return (
    <div style={{ maxWidth: "320px", width: "100%" }}>
      <Grid container justifyContent="start" alignItems="start">
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          style={{ marginBottom: 20 }}
        >
          <Grid>
            <CustomTypo>{t("outro.selectedLocation")}:</CustomTypo>
          </Grid>
          <Grid>
            <Typography
              // className={classes.custom}
              style={{ color: brandColors[brand].secondary }}
            >
              {appointmentLocation.displayName}
            </Typography>
          </Grid>
        </Grid>
        {availableDates[0].CurrentState === "Undefined" ? (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ height: 358, width: 320 }}
          >
            <RingLoader />
          </Grid>
        ) : availableDates[0].CurrentState === "None" ? (
          <Grid
            container
            direction="row"
            justifyContent="center"
            style={{ marginTop: 30, width: 320 }}
          >
            <CustomIcon brand={brand} />
            <CustomCardTypo>{t("outro.noAppointmentsAvail")}</CustomCardTypo>
          </Grid>
        ) : availableDates[0].CurrentState !== "Undefined" ? (
          <Grid container direction="row" justifyContent="center">
            <Grid
              style={{
                outlineWidth: "thick",
                outlineStyle: "ridge",
                outlineColor: brandColors[brand].secondary,
                width: 308,
              }}
            >
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={locale}
              >
                <DateCalendar
                  defaultValue={initialValue}
                  // view="day"
                  views={["year", "month", "day"]}
                  date={selectedDate}
                  maxDate={maxDate}
                  showDaysOutsideCurrentMonth
                  onChange={handleDateChange}
                  shouldDisableDate={(date) => {
                    return IsDayNotAvailable(date);
                  }}
                  minDate={new Date()}
                  // slots={{
                  //   day: DiscountedDays,
                  // }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        ) : null}
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ padding: "25px 0px", width: "100%" }}
        >
          <Grid>
            <BackButton
              brand={brand}
              aria-label="return"
              variant="contained"
              // className={classes.backButton}
              size="medium"
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => handleGoBack()}
              disabled={availableDates[0].CurrentState === "Undefined"}
            >
              {t("outro.backToLocations")}
            </BackButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

AppointmentCalendar.propTypes = {
  availableDates: PropTypes.array,
  loadAvailableDates: PropTypes.func.isRequired,
  resetAvailableDates: PropTypes.func.isRequired,
  appointmentLocation: PropTypes.object,
  selectedDate: PropTypes.instanceOf(Date),
  setSelectedDate: PropTypes.func.isRequired,
  previousStep: PropTypes.func.isRequired,
  enrolleeUserData: PropTypes.object.isRequired,
  prefillDeviceType: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    availableDates: state.availableDates,
  };
}

const mapDispatchToProps = {
  loadAvailableDates,
  resetAvailableDates,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppointmentCalendar);
